const apiKey = import.meta.env.VITE_AUTHENTICATION_API_KEY;

if (!apiKey) {
  throw new Error("API Key is missing from environment variables.");
}

const desconnectInstance = async (instanceId: any, connectionStatus: any): Promise<any> => {
  if (connectionStatus && connectionStatus !== 'close') {
    try {
      await fetch(`https://evolutionapi.cabanalink.com/instance/logout/${instanceId}`, {
        method: 'DELETE',
        headers: {
          apikey: apiKey,
          'Content-Type': 'application/json'
        }
      });
    } catch (error) {
      console.error('Erro ao desconectar instância:', error);
    }
  } else return;
}

export default desconnectInstance;